import { SimpleApp } from '../../libs/apps';
import { AppsResponse, AppsData } from './types';

/**
 * Takes the apps data response and transforms it into
 * the form we want to use in our React state
 *
 * @param response the response returned by calling /applications/
 */
export function createAppsData(response: AppsResponse): AppsData {
  const apps = Object.keys(response.apps);
  for (const appKey of apps) {
    const app: SimpleApp = response.apps[appKey];
    if (!app.isCustomProgram) {
      if (app.friendlyName) {
        app.name = app.friendlyName;
      } else {
        const rawName = app.name || '';
        const baseName = rawName.startsWith('Epx') ? rawName.slice(3) : rawName;
        const nameParts = baseName.match(/[A-Z]+[^A-Z]*|[^A-Z]+/g);
        app.name = (nameParts || [baseName]).join(' ').trim();
      }
    }
  }
  return {
    apps: response.apps,
    tags: response.tags
  };
}
